import {
    Box,
    Link as LinkStyle,
    Table,
    Tbody,
    Td,
    Th,
    Thead,
    Tr
} from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";
import { Title } from "../../components/Title";
import { useAllDoctorRequestsQuery } from "../../graphql";

import { formatDateTime } from "../../utils";

const DoctorRequests: React.FC = () => {
    const { data, loading } = useAllDoctorRequestsQuery();

    return (
        <>
            <Box
                borderWidth="1px"
                borderRadius="lg"
                overflow="hidden"
                p={ 2 }
                background="white"
            >
                <>
                    <Title title="Aplikime për mjek"></Title>

                    <Table variant="striped" size="sm">
                        <Thead>
                            <Tr>
                                <Th>Emri</Th>
                                <Th>Telefoni</Th>
                                <Th>Email</Th>
                                <Th>Qyteti</Th>
                                <Th isNumeric>Data</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            { data?.doctorRequests.map((request) => (
                                <Tr key={ request.id }>
                                    <Td>
                                        <LinkStyle>
                                            <Link to={ `/request/${request.id}` }>
                                                { request.name } { request.lastname }
                                            </Link>
                                        </LinkStyle>
                                    </Td>
                                    <Td>{ request.phoneNumber }</Td>
                                    <Td>{ request.email }</Td>
                                    <Td>{ request.city.name }</Td>
                                    <Td isNumeric> { formatDateTime(request.createdAt) }</Td>
                                </Tr>
                            )) }
                        </Tbody>
                    </Table>
                </>
            </Box>
        </>
    );
};

export default DoctorRequests;
